import { Injectable } from '@angular/core';
import { RecordsCoudPouce } from '@classes/records/record';
import { UserPlatform } from '@classes/user/user-platform';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  isAdmin = new BehaviorSubject<boolean>(false);
  usersList$ = new BehaviorSubject<UserPlatform[]>([]);
  typeTime$ = new BehaviorSubject<string>('month');
  dataGraph$ = new BehaviorSubject<RecordsCoudPouce[]>([]);
  selectFC$ = new BehaviorSubject<string>('Générique');
  // userNameUpdate = new BehaviorSubject<String

  constructor() { }
}
